import { render, staticRenderFns } from "./FieldSchemaEditor.vue?vue&type=template&id=261a4d20&"
import script from "./FieldSchemaEditor.vue?vue&type=script&lang=js&"
export * from "./FieldSchemaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports